import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-647f0a16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border-top":"1px solid var(--ion-color-black)"} }, null, -1))
const _hoisted_3 = { class: "ion-padding-bottom" }

import {
  AdminProjectClass,
  Course,
  CustomElement,
  GeneralCardElements,
  OrderedCardsList,
  TeacherProposition,
  TeacherSummary,
  User,
} from "@/types";
import {
  executeLink,
  getBreakpoint,
  getCurrentElement,
  getCustomMessage,
  getIcon,
  isSmaller,
} from "@/utils";
import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonSegment,
  IonSegmentButton,
} from "@ionic/vue";
import "swiper/css";
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDescription',
  props: {
  title: {
    type: String,
    required: true,
  },
  course_id: {
    type: Number,
    required: true,
  },
  learning_session_id: String,
  section: String,
},
  emits: ["close"],
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;

const changeMode = (event: CustomEvent) => {
  mode.value = event.detail.value;
};
const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};



const user = User.getLoggedUser() as User;

const elements: {
  [key: string]: CustomElement;
} = {
  close: {
    id: "close",
    type: "icon",
    linkType: "event",
    content: {
      event: "close",
      icon: getIcon("close"),
    },
  },
  title: {
    id: "title",
    type: "title",
    content: props.title,
  },
  course_information_not_found: {
    id: "course_information_not_found",
    type: "string",
    content: getCurrentElement("course_information_not_found"),
  },
};
const breakpoint = ref(getBreakpoint(window.innerWidth));
const course = (
  ([__temp,__restore] = _withAsyncContext(() => Course.newCourse("/v1/courses/" + props.course_id))),
  __temp = await __temp,
  __restore(),
  __temp
);

const access_cards = course.getAccessCardsList();
const growth_cards = course.getGrowthCardsList();
const teachings_cards = course.getTeachingCardsList();
const mode = ref("course");
const teachers_list: OrderedCardsList = {
  order: [],
  cards: {},
};

let course_card: GeneralCardElements;
let project_class_card: GeneralCardElements | undefined;

if (course != null) {
  course_card = course.toCard();
}
if (props.learning_session_id != undefined) {
  project_class_card = (
  ([__temp,__restore] = _withAsyncContext(async () => executeLink(
    "/v1/project_classes/" + course.id + "/" + props.learning_session_id,
    async (response) => {
      const tmp_project_class = new AdminProjectClass(response.data.data);
      await tmp_project_class.loadParms();

      let actual_section: string | undefined;

      if (user.type == "student") {
        actual_section =
          props.section ??
          (await executeLink(
            "/v1/students/" +
              user.id +
              "/project_classes?session_id=" +
              props.learning_session_id,
            (response) => {
              let count = 0;
              let tmp_section: string;

              while (
                (tmp_section =
                  response.data.data[count].id == course.id
                    ? response.data.data[count].section
                    : undefined) == undefined &&
                ++count < response.data.data.length
              );

              return tmp_section;
            },
            () => undefined
          ));
      }

      return tmp_project_class.toCard(
        undefined,
        actual_section,
        true,
        false,
        user.type != "student",
        user
      );
    },
    () => undefined
  ))),
  __temp = await __temp,
  __restore(),
  __temp
);
  teachers_list.cards[""] = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v1/project_classes/" +
      course.id +
      "/" +
      props.learning_session_id +
      "/teachers",
    (response) => {
      const summmary_teachers: {
        [id: string]: {
          teacher: TeacherSummary;
          main: boolean;
        };
      } = {};
      const sections: {
        [id: string]: string[];
      } = {};
      const teachers: GeneralCardElements[] = [];

      let tmp_id: number, tmp_card: GeneralCardElements;

      for (const teacher_section of response.data.data) {
        tmp_id = teacher_section.teacher_ref.data.id;

        summmary_teachers[tmp_id] = {
          teacher: new TeacherSummary({
            id: tmp_id,
            name: teacher_section.teacher_name,
            surname: teacher_section.teacher_surname,
          }),
          main: teacher_section.main_teacher === 1,
        };

        if (sections[tmp_id] == undefined) {
          sections[tmp_id] = [];
        }
        sections[tmp_id].push(teacher_section.section);
      }

      for (const teacher_id of Object.keys(summmary_teachers)) {
        tmp_card = new TeacherProposition(
          summmary_teachers[teacher_id].teacher,
          summmary_teachers[teacher_id].main,
          sections[teacher_id]
        ).toCard(true);
        for (const element of tmp_card.content as CustomElement[]) {
          element.colors = {
            text: {
              name: "white",
              type: "var",
            },
            background: {
              name: "tur4",
              type: "var",
            },
          };
        }
        (tmp_card.content as CustomElement[])[0].classes = {
          label: {
            "ion-text-wrap": true,
            "ion-padding": true,
            "ion-text-center": true,
            radius: true,
          },
        };
        tmp_card.classes = {
          content: {
            "ion-no-padding": true,
          },
        };
        teachers.push(tmp_card);
      }

      return teachers;
    },
    () => []
  ))),
  __temp = await __temp,
  __restore(),
  __temp
);
}

onMounted(() =>
  nextTick(() => {
    window.addEventListener("resize", updateBreakpoint);
  })
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateBreakpoint);
});

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_list_card = _resolveComponent("list-card")!
  const _component_image_carousel = _resolveComponent("image-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), { class: "ion-text-center ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.title
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol), { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.close,
                          onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(course) != undefined && __props.learning_session_id != undefined)
              ? (_openBlock(), _createBlock(_unref(IonSegment), {
                  key: 0,
                  value: "course",
                  onIonChange: changeMode
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonSegmentButton), { value: "course" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: _unref(getCustomMessage)('course', _unref(getCurrentElement)('course'))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSegmentButton), { value: "project_class" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: _unref(getCustomMessage)('class', _unref(getCurrentElement)('class'))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_unref(course) != undefined)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (mode.value == 'course')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_list_card, {
                        emptiness_message: 
              _unref(getCustomMessage)(
                'emptiness_message',
                _unref(getCurrentElement)('course_for_noone')
              )
            ,
                        cards_list: _unref(access_cards),
                        columns: _unref(isSmaller)(breakpoint.value, 'sm') ? 2 : 3,
                        colors: {
              background: {
                name: 'white',
                type: 'var',
              },
              dividers: {
                name: 'white',
                type: 'var',
              },
            },
                        classes: {
              card: {
                no_card_border: true,
                'ion-no-margin': true,
              },
              content: {
                'ion-no-padding': true,
              },
              item: {
                'ion-no-padding': true,
              },
              row: {
                'ion-wrap': true,
              },
            }
                      }, null, 8, ["emptiness_message", "cards_list", "columns"]),
                      _hoisted_2,
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_image_carousel, {
                          images: _unref(course).images_list
                        }, null, 8, ["images"])
                      ]),
                      _createElementVNode("b", null, [
                        _createVNode(_component_ionic_element, {
                          element: 
                _unref(getCustomMessage)(
                  'context_description',
                  _unref(getCurrentElement)('context_description').toUpperCase()
                )
              
                        }, null, 8, ["element"])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(course_card).content, (element) => {
                        return (_openBlock(), _createBlock(_component_ionic_element, {
                          key: element.id,
                          element: element
                        }, null, 8, ["element"]))
                      }), 128)),
                      _createElementVNode("b", null, [
                        _createVNode(_component_ionic_element, {
                          element: 
                _unref(getCustomMessage)(
                  'teachings',
                  _unref(getCurrentElement)('teachings') + ':'
                )
              
                        }, null, 8, ["element"])
                      ]),
                      _createVNode(_component_list_card, {
                        emptiness_message: 
              _unref(getCustomMessage)(
                'emptiness_message',
                _unref(getCurrentElement)('no_teachings')
              )
            ,
                        cards_list: _unref(teachings_cards),
                        columns: _unref(isSmaller)(breakpoint.value, 'sm') ? 1 : 2,
                        colors: {
              background: {
                name: 'white',
                type: 'var',
              },
              dividers: {
                name: 'white',
                type: 'var',
              },
            },
                        classes: {
              card: {
                no_card_border: true,
                'ion-no-margin': true,
              },
              content: {
                'ion-no-padding': true,
              },
              item: {
                'ion-no-padding': {
                  general: true,
                  md: false,
                },
                'ion-padding-bottom': {
                  md: true,
                },
              },
              row: {
                'ion-wrap': true,
              },
            }
                      }, null, 8, ["emptiness_message", "cards_list", "columns"]),
                      _createElementVNode("b", null, [
                        _createVNode(_component_ionic_element, {
                          element: 
                _unref(getCustomMessage)(
                  'growth_areas',
                  _unref(getCurrentElement)('growth_areas') + ':'
                )
              
                        }, null, 8, ["element"])
                      ]),
                      _createVNode(_component_list_card, {
                        emptiness_message: 
              _unref(getCustomMessage)(
                'emptiness_message',
                _unref(getCurrentElement)('no_growth_areas')
              )
            ,
                        cards_list: _unref(growth_cards),
                        columns: _unref(isSmaller)(breakpoint.value, 'sm') ? 1 : 2,
                        colors: {
              background: {
                name: 'white',
                type: 'var',
              },
              dividers: {
                name: 'white',
                type: 'var',
              },
            },
                        classes: {
              card: {
                no_card_border: true,
                'ion-no-margin': true,
              },
              content: {
                'ion-no-padding': true,
              },
              item: {
                'ion-no-padding': {
                  general: true,
                  md: false,
                },
                'ion-padding-bottom': {
                  md: true,
                },
              },
              row: {
                'ion-wrap': true,
              },
            }
                      }, null, 8, ["emptiness_message", "cards_list", "columns"])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(project_class_card) != undefined)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(project_class_card).content, (element) => {
                            return (_openBlock(), _createBlock(_component_ionic_element, {
                              key: element.id,
                              element: element
                            }, null, 8, ["element"]))
                          }), 128))
                        : _createCommentVNode("", true),
                      _createElementVNode("b", null, [
                        _createVNode(_component_ionic_element, {
                          element: 
                _unref(getCustomMessage)(
                  'teachers_title',
                  _unref(getCurrentElement)('teachers') + ': '
                )
              
                        }, null, 8, ["element"])
                      ]),
                      _createVNode(_component_list_card, {
                        emptiness_message: 
              _unref(getCustomMessage)(
                'emptiness_message',
                _unref(getCurrentElement)('no_teachers')
              )
            ,
                        cards_list: teachers_list,
                        columns: _unref(isSmaller)(breakpoint.value, 'sm') ? 1 : 2,
                        colors: {
              background: {
                name: 'white',
                type: 'var',
              },
              dividers: {
                name: 'white',
                type: 'var',
              },
            },
                        classes: {
              card: {
                no_card_border: true,
                'ion-no-margin': true,
              },
              content: {
                'ion-no-padding': true,
              },
              item: {
                'ion-no-padding': {
                  general: true,
                  md: false,
                },
                'ion-padding-bottom': {
                  md: true,
                },
              },
              row: {
                'ion-wrap': true,
              },
            }
                      }, null, 8, ["emptiness_message", "columns"])
                    ], 64))
              ], 64))
            : (_openBlock(), _createBlock(_component_ionic_element, {
                key: 1,
                element: elements.course_information_not_found
              }, null, 8, ["element"]))
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})